import {createError} from '@services/errors';
import config from 'config';
import {buildFetch} from '@services/fetch';
import Immutable from 'immutable';

import {getUserId} from '@reducers/user';

export const QUESTIONNAIRE360_LOADING_START = 'QUESTIONNAIRE360_LOADING_START';
export const QUESTIONNAIRE360_LOADING_SUCCESS = 'QUESTIONNAIRE360_LOADING_SUCCESS';
export const QUESTIONNAIRE360_LOADING_ERROR = 'QUESTIONNAIRE360_LOADING_ERROR';
export const UPDATE_SKILLUP360_STATUS_ERROR = 'UPDATE_SKILLUP360_STATUS_ERROR';

export function loadQuestionnaire360Success(data = {}) {
  return {
    type: QUESTIONNAIRE360_LOADING_SUCCESS,
    data,
  };
}

export function loadQuestionnaire360Start() {
  return {
    type: QUESTIONNAIRE360_LOADING_START,
  };
}

export const loadQuestionnaire360Error = createError(QUESTIONNAIRE360_LOADING_ERROR);

export function loadQuestionnaire360(campaign_id) {
  return function(dispatch) {
    const fetch = buildFetch(dispatch);
    dispatch(loadQuestionnaire360Start());

    return fetch(`${config.api}/usercampaign/${campaign_id}/userrelation`)
      .then(response => {
        const {relations} = response.data;
        const data = Immutable.fromJS(relations);

        dispatch(loadQuestionnaire360Success(data));
        return data;
      })
      .catch(error => {
        if (!error) return;

        dispatch(loadQuestionnaire360Error(error.message));
        throw error;
      });
  };
}

export const updateSkillup360StatusError = createError(UPDATE_SKILLUP360_STATUS_ERROR);

export function updateSkillup360Status(campaign_id, test_id, status) {
  return function(dispatch, getState) {
    const fetch = buildFetch(dispatch);
    const user_id = getUserId(getState());

    const payload = {
      version: status === 'complete' ? 2 : 1,
      status,
    };

    return fetch(`${config.api}/tests/${test_id}/status/${campaign_id}/${user_id}`, {
      method: 'POST',
      data: payload,
    })
      .then(response => {
        const resp = response.data;
        return resp;
      })
      .catch(error => {
        if (!error) return;

        console.log(error.response);

        // dispatch(updateSkillup360StatusError(error.message));
        // throw error;
      });
  };
}
